import { Grid } from '@purpur/library';
import styled, { css } from 'styled-components';
import { match } from 'ts-pattern';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';
import { NAVIGATION_OFFSET_CSS_VARIABLE } from '@telialt/utils/src/NavigationUtils/constants';

import { BlockSection } from '../common/Common.styles';
import { ValuePromptColorVariant, ValuePromptVariant } from './model';

const getBackgroundByColorVariant = (colorVariant: ValuePromptColorVariant) => {
    return match(colorVariant)
        .with('light-grey', () => getPurpurColor('backgroundSecondary'))
        .with('light-purple', () => getPurpurColor('backgroundToneOnToneSecondary'))
        .with('light-beige', () => getPurpurColor('backgroundToneOnToneQuaternary'))
        .with('no-background', () => getPurpurColor('functionalTransparent'))
        .exhaustive();
};

export const ValuePromptBlockSection = styled(BlockSection)<{
    $variant: ValuePromptVariant;
    $colorVariant: ValuePromptColorVariant;
}>`
    scroll-margin-top: var(${NAVIGATION_OFFSET_CSS_VARIABLE});
    ${({ $colorVariant, $variant }) =>
        $variant === 'compact' &&
        css`
            background: ${getBackgroundByColorVariant($colorVariant)};
            padding-top: ${getPurpurSpacing('250')};
            padding-bottom: ${getPurpurSpacing('250')};

            ${purpurMedia('md')`
                padding-top: ${getPurpurSpacing('300')};
                padding-bottom: ${getPurpurSpacing('300')};
            `}
        `}
`;

export const ValuePromptBlockContainer = styled(Grid)<{
    $variant: ValuePromptVariant;
    $colorVariant: ValuePromptColorVariant;
}>`
    ${({ $colorVariant, $variant }) =>
        $variant === 'illustrative' &&
        css`
            background: ${getBackgroundByColorVariant($colorVariant)};
            padding: ${getPurpurSpacing('300')};
            border-radius: ${getPurpurBorder('radiusLg')};

            ${
                $colorVariant === 'light-grey' &&
                css`
                    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderWeak')};
                `
            }

            ${
                $colorVariant === 'no-background' &&
                css`
                    padding: 0;
                `
            };

            ${purpurMedia('lg')`
                padding: ${getPurpurSpacing('400')};

                ${
                    $colorVariant === 'no-background' &&
                    css`
                        padding: 0;
                    `
                };
            `}
        `}
`;

export const ValuePromptBlockGrid = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: grid;
    gap: ${getPurpurSpacing('300')};

    ${purpurMedia('lg')`
        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    `}
`;
